import { IOptionModel } from "@/interfaces/iPageModel";
import { ApiService } from "./AbstractApiService";

export class GlobalFilterApi extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: GlobalFilterApi | null;
  constructor() {
    super("site");
  }
  public async getSiteList(): Promise<Array<IOptionModel>> {
    return this.get("filter/SITES").then((response) => response.data);
  }
}
